import CheckIcon from '/public/icons/check-gray.svg'
import FgtIconPink from '/public/images/fgt-pink.webp'
import logoPlay from '/public/images/play.webp'
import logoPlayAoVivo from '/public/images/play-aovivo.webp'
import pricePlay from '/public/images/price-play.webp'
import pricePlayAoVivo from '/public/images/price-play-aovivo.webp'

export const PLAY = {
  id: 'play',
  disclaimer: 'Apenas aulas gravadas',
  logo: logoPlay,
  priceImage: pricePlay,
  value: '29,90',
  list: [
    { content: 'Aulas gravadas para assistir quando e de onde quiser' },
    { content: 'Lançamentos mensais de novas aulas gravadas' },
    { content: 'Treinos para iniciantes, intermediários e avançados' },
    { content: 'Séries especiais: caneleira, abdômen, metabólico e outras' },
    { content: 'Guias alimentares personalizados' },
    { icon: CheckIcon },
    { icon: CheckIcon },
    { icon: CheckIcon },
    { icon: CheckIcon },
    { icon: CheckIcon },
    { icon: CheckIcon }
  ]
}

export const PLAY_AOVIVO = {
  id: 'live',
  disclaimer: 'Aulas gravadas + Aulas ao vivo',
  logo: logoPlayAoVivo,
  priceImage: pricePlayAoVivo,
  value: '39,80',
  list: [
    {
      content: 'Aulas gravadas para assistir quando e de onde quiser'
    },
    { content: 'Lançamentos mensais de novas aulas gravadas' },
    { content: 'Treinos para iniciantes, intermediários e avançados' },
    { content: 'Séries especiais: caneleira, abdômen, metabólico e outras' },
    { content: 'Guias alimentares personalizados' },
    {
      icon: FgtIconPink,
      content:
        'Mais de 300 aulas Ao Vivo por mês para você encaixar na sua rotina'
    },
    {
      icon: FgtIconPink,
      content: 'Mais de 10 Modalidades de treinos Ao Vivo'
    },
    {
      icon: FgtIconPink,
      content: 'Aulas de 5h às 21h, de segunda a sábado'
    },
    {
      icon: FgtIconPink,
      content: 'Treinos dinâmicos e ao vivo para todos os níveis'
    },
    {
      icon: FgtIconPink,
      content:
        'Treinos interativos: correções e dúvidas ao vivo com o professor'
    },
    {
      icon: FgtIconPink,
      content:
        'Sinta a energia de centenas de pessoas treinando ao mesmo tempo que você'
    }
  ]
}
